// @ts-ignore try to make it work in common js for tests
typeof module !== "undefined" && (module.exports = { Q: Q, Serenity: Serenity, __extends: __extends });